import React from 'react';
import Button from "react-bootstrap/Button";
import {concepts, Institute} from "fearless-common";
import {PlusLg} from "react-bootstrap-icons";
import { ColumnDef} from "@tanstack/react-table";
import {adminRoutes} from "../../utils/routes";
import Pages from "../../components/layout/Pages";
import OrderableTable from "../../components/layout/OrderableTable";
import {backendEndpoints} from "../../libs/backendEndpoints";
import useTitle from "../../components/hooks/useTitle";
import Description from "../../components/Description";

const columns: ColumnDef<Institute>[] = [
    { id: 'id', accessorKey: 'id', header: 'ID', enableSorting: true },
    { id: 'name', accessorKey: 'name', header: 'Name', enableSorting: true },
];

/**
 * Show a table of all institutes.
 */
export default function AdminInstitutes() {
    useTitle(`Admin ${concepts.Institutes}`);
    return (
        <Pages.Centred padded>
            <div className="d-inline-flex align-items-center gap-4">
              <h1>{concepts.Institutes}</h1>
              <Button size="sm" href={adminRoutes.addInstitute} variant="outline-primary"><PlusLg /> add</Button>
            </div>
            <Description className="neutral-500">
              Institutes are now backend "super" groups to which we can link groups, rules and subscriptions.
              Groups cannot assign themselves to institutes themselves;
              only {concepts.CompanyName} admins can.
            </Description>
            <OrderableTable<Institute>
                baseEndpoint={backendEndpoints.getAdminInstitutes}
                memoisedColumns={columns}
                buildLink={(record) => adminRoutes.institute(record.id)}
            />
        </Pages.Centred>
    );
}
